import { ApiRebalancingDefinition } from '../api'
import { availableTolerances } from './available-tolerances'

export const handleDefaultRebalancingDefinition = (
  rebalancingDefinition: ApiRebalancingDefinition
): ApiRebalancingDefinition => {
  if (rebalancingDefinition?.type === 'None') {
    return {
      type: 'None',
      frequency: null,
      weightsTolerance: null
    }
  }

  const frequency =
    rebalancingDefinition?.type === 'Weight' ? null : rebalancingDefinition?.frequency ?? 'Monthly'

  const weightsTolerance =
    rebalancingDefinition?.type !== 'Weight'
      ? null
      : rebalancingDefinition?.weightsTolerance ?? availableTolerances[0]

  return {
    type: rebalancingDefinition?.type,
    frequency,
    weightsTolerance
  }
}
